﻿let Sizer = require('./Sizer.js');
let $ = require('jquery');

let SizerBreakpoint = function (customOptions) {
    let defaultSizes = [
            {
                maxWidth: 768 - 1,
                cssClass: 'sizer-mobile'
            },
            {
                maxWidth: 950 - 1,
                cssClass: 'sizer-tablet'
            }
    ];

    new Sizer({
        element: customOptions.element,
        sizes: defaultSizes
    });

    if ('extraSizes' in customOptions) {
        new Sizer({
            element: customOptions.element,
            sizes: customOptions.extraSizes
        });
    }
};

module.exports = SizerBreakpoint;